import { ContactUs, CopyrightFooter, DataChart } from 'app/components'
import { Container, IAppState } from 'app/containers/Container'
import * as React from 'react'
import { Button, Carousel, Col, Panel, Row, Tab, Tabs, Well, Table } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Document, Page, StyleSheet } from 'react-pdf';
import { FoundationMark50Details } from '../FoundationMark50Details';

interface IIrsFilingState {
  url?: string
  isLoading?: boolean
  irsFiling?: string
  pageNumber?: number
  numPages?: number
  foundationName?: string
  yearEnd?: string
  ein?: string
}

class IrsFilingContainer extends Container<{}, IIrsFilingState> {

  mapAppStateToContainerState(appState: IAppState): IIrsFilingState {
    return {
      url: null,
      isLoading: true,
      irsFiling: '',
      pageNumber: null,
      numPages: null,
      yearEnd: '',
      ein: '',
    }
  }

  state: IIrsFilingState = {
    url: null,
    isLoading: true,
    irsFiling: '',
    pageNumber: 1,
    numPages: 0,
    foundationName: '',
    yearEnd: '',
    ein: '',
  }

  constructor(props) {
    super(props)
    this.previousPage = this.previousPage.bind(this)
    this.nextPage = this.nextPage.bind(this)
  }

  componentWillMount() {
    const irsFilingInfo = window.localStorage.getItem(FoundationMark50Details.irsFilingKey)
    let pageInformation = undefined
    try {
      pageInformation = JSON.parse(irsFilingInfo)
      this.setState({ irsFiling: pageInformation.fileName, pageNumber: pageInformation.pageNumber, foundationName: pageInformation.foundationName, yearEnd: pageInformation.yearEnd, ein: pageInformation.ein }, this.fetchFilingUrl)
    } catch (err) { console.log(err) }
  }

  fetchFilingUrl() {
    const { irsFiling } = this.state

    const method = 'POST'
    const params = { action: 'getPDF', request: { assetLevel: 0, state: '', name: irsFiling, monthNumber: '12' } }
    const body = JSON.stringify(params)
    const request = { method, body }
    fetch('https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', request)
      .then((resp) => resp.text())
      .then((text) => {
        this.setState({ isLoading: false, url: text })
      })
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  }

  previousPage() {
    const { pageNumber } = this.state

    let newPageNumber = 1
    if (pageNumber > 1) {
      newPageNumber = pageNumber - 1
    }
    this.setState({ pageNumber: newPageNumber })
  }

  nextPage() {
    const { pageNumber, numPages } = this.state

    let newPageNumber = pageNumber
    if (numPages > 1 && numPages !== pageNumber) {
      newPageNumber = pageNumber + 1
    }
    this.setState({ pageNumber: newPageNumber })
  }

  render() {
    const { isLoading, pageNumber, url, numPages, foundationName, yearEnd, ein } = this.state
    const href = '#/foundationmark15details?ein=' + ein

    return (
      <section className="container" style={{ paddingTop: '40px' }}>
        <h4 className="text-center">{foundationName} - {yearEnd}&nbsp;{isLoading &&
          <i className="fa fa-cog fa-spin"></i>
        }</h4>
        {!isLoading &&
          <section style={{ textAlign: 'center' }}>
            <Row>
              <Col xs={12} md={4}>
                <button className="btn btn-primary" onClick={this.previousPage}>Previous</button>&nbsp;
                <button className="btn btn-primary" onClick={this.nextPage}>Next</button>
              </Col>
              <Col xs={12} md={4}>
                Page {pageNumber} of {numPages}&nbsp;
              </Col>
              <Col xs={12} md={4}>
                <a className="btn btn-primary" href={href}>Back</a>
              </Col>
            </Row>
            <Row>
              <Col xs={12} style={{ left: '25%', top: '50%' }}>
                <Document
                  file={url}
                  onLoadSuccess={this.onDocumentLoadSuccess}>
                  <Page pageNumber={pageNumber} size="A4" />
                </Document>
              </Col>
            </Row>
          </section>
        }
      </section >
    )
  }
}

export {
  IrsFilingContainer,
}


// WEBPACK FOOTER //
// ./src/app/containers/IrsFiling/index.tsx